import React from "react";
import { CATEGORY_META } from "@/lib/constants";
import StatusBadge from "@/components/StatusBadge";
import { FolderKanban, ListChecks } from "lucide-react";

export default function SearchResults({ q, query, loading, res, empty, onGo }) {
  return (
    <div className="max-h-[60vh] overflow-y-auto p-2">
      {query.length < 2 && <p className="p-4 text-sm text-zinc-400">Type at least 2 characters to search.</p>}
      {query.length >= 2 && loading && <p className="p-4 text-sm text-zinc-400">Searching…</p>}
      {empty && <p className="p-4 text-sm text-zinc-400" data-testid="search-no-results">No matches for “{q}”.</p>}

      {res.projects.length > 0 && (
        <p className="px-2 pt-2 pb-1 text-[10px] font-semibold uppercase tracking-wider text-zinc-400">Projects</p>
      )}
      {res.projects.map((p) => (
        <button key={p.project_id} onClick={() => onGo(`/project/${p.project_id}`)}
          data-testid={`search-project-${p.project_id}`}
          className="w-full flex items-center gap-3 px-2 py-2 rounded-sm hover:bg-zinc-100 text-left transition-colors">
          <FolderKanban className="h-4 w-4 text-zinc-500 shrink-0" />
          <span className="flex-1 min-w-0">
            <span className="text-sm font-medium block truncate">{p.name}</span>
            <span className="text-xs text-zinc-400 truncate block">
              {p.builder ? `${p.builder} · ` : ""}{(CATEGORY_META[p.category] || {}).label || ""}
            </span>
          </span>
        </button>
      ))}

      {res.tasks.length > 0 && (
        <p className="px-2 pt-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-zinc-400">Tasks</p>
      )}
      {res.tasks.map((t) => (
        <button key={t.task_id} onClick={() => onGo(`/project/${t.project_id}`)}
          data-testid={`search-task-${t.task_id}`}
          className="w-full flex items-center gap-3 px-2 py-2 rounded-sm hover:bg-zinc-100 text-left transition-colors">
          <ListChecks className="h-4 w-4 text-zinc-500 shrink-0" />
          <span className="flex-1 min-w-0">
            <span className="text-sm font-medium block truncate">{t.name}</span>
            <span className="text-xs text-zinc-400 truncate block">{t.builder ? `${t.builder} · ` : ""}{t.project_name}</span>
          </span>
          <StatusBadge status={t.status} />
        </button>
      ))}
    </div>
  );
}
